import React from 'react';

import Header from '../../components/user/header/Header.jsx';
import SubIntro from '../../components/user/sub_intro2/Intro.jsx';
import Content from '../../components/user/sub2_1/sub2_1_3/Content.jsx';

import Footer from '../../components/user/footer/Footer.jsx';

import s2_1_3_bg from '../../assets/images/s2_1_3_bg.png';

import '../../styles/user/common.css';
import '../../styles/user/default.css';
import '../../styles/user/fixed.css';
import '../../styles/user/font.css';
import '../../styles/user/footer.css';
import '../../styles/user/header.css';
import '../../styles/user/main.css';
import '../../styles/user/slick-theme.css';
import '../../styles/user/slick.css';
import '../../styles/user/sub.css';

export default function Sub2_1_3() {
  return (
    <>
      <Header />
      <SubIntro
        backgroundImage={s2_1_3_bg}
        mainTitle="프리미엄 서빙로봇"
        productName="CREAMBOT"
        productModel="T9"
        description="업그레이드 된 인터페이스 환경으로
쉽고 편리한 사용"
        theme="dark"
        showWhiteFilter={true}
      />
      <Content />
      <Footer />
    </>
  );
}
